export default __webpack_public_path__ + "static/media/_HD24.de AGB_Backend.c9a9e87b.pdf";